export default __webpack_public_path__ + "static/perfect-pair.light-621b1f22875691bd39d0a7f09ca3f07020edb08967fcae21d5c579a7f57d4240.png";